<button
  mhFilterTrigger
  [filterOpen]="isOpen"
  (click)="isOpen = !isOpen" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
  >
  <!-- En móvil el control es un círculo con solo el ícono -->
  <i class="fas fa-align-left tw-text-neutral-500 md:tw-hidden"></i>
  <span class="tw-hidden tw-max-w-64 tw-truncate md:tw-block">
    {{'commons.surveys' | translate}}:
    <ng-container *ngTemplateOutlet="selectedSurveys"></ng-container>
  </span>
  <i class="fal fa-angle-down tw-hidden tw-text-base tw-ml-1 tw-text-neutral-400 md:tw-inline"></i>
</button>


<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
>
<article class="tw-rounded-lg tw-shadow-xl tw-p-3 tw-bg-white tw-max-w-sm tw-mt-1" id="overlaySelectorSurvey">
  <mh-core-lib-tag-input
    [options]="surveys$ | async"
    [selectedOptions]="surveysSelected"
    [displayChipsFn]="displayFn"
    [displayChipsListFn]="displayFn"
    (optionClicked)="handleOptionClicked($event)"
  ></mh-core-lib-tag-input>
</article>
</ng-template>

<ng-template #selectedSurveys>
  <ng-container *ngIf="areAllSurveysSelected">
    {{buttonLabel | translate}}
  </ng-container>
  <ng-container *ngIf="!areAllSurveysSelected">
    {{surveysSelected.length}} {{buttonLabel | translate}}
  </ng-container>
</ng-template>
